module.exports = __webpack_public_path__ + "img/180.293c095f.jpg";